/* Configuração da conexão e sessão de login, guardadas no navegador (localStorage). */

export type Modo = 'demo' | 'api';

export interface Config {
  modo: Modo;
  /** URL do backend calculadora_emissoes, sem /api/v1. */
  base: string;
  /** API key do usuário (X-API-Key), para integrações; o login usa o token de sessão. */
  apiKey: string;
  /** Token de sessão do login (Authorization: Bearer). Vazio = sem login. */
  token: string;
  usuario: { id: string; nome: string | null; email: string | null; preferencias?: { tema?: 'claro' | 'escuro' } } | null;
  /** CNPJ escolhido entre os liberados para o usuário (vazio = o primeiro). */
  cnpj: string;
  ano: number;
}

const CHAVE = 'znit-plataforma-config';
export const BACKEND_PADRAO = 'https://backend-sn1n.onrender.com';

export const CFG: Config = { modo: 'demo', base: BACKEND_PADRAO, apiKey: '', token: '', usuario: null, cnpj: '', ano: new Date().getFullYear() };

try {
  Object.assign(CFG, JSON.parse(localStorage.getItem(CHAVE) || '{}'));
} catch {
  /* navegador sem localStorage: segue com o padrão */
}

export function salvarCfg(): void {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(CFG));
  } catch {
    /* sem localStorage: a configuração vale só nesta aba */
  }
}

export const isApi = (): boolean => CFG.modo === 'api';
